import React from "react";
import { Wrapper, InfoWrapper, Content, StyledImage } from "./style";
import { Loader } from "../../style/shared";

const ImageSection = ({ content }) => (
  <Wrapper>
    <StyledImage
      src="/images/profile/dmf-72.jpg"
      alt="Background Image"
      className="img1"
      sources={[
        {
          srcset: [
            "/images/profile/dmf-72.jpg 1x",
            "/images/profile/dmf-72.jpg 2x",
          ],
        },
      ]}
    />
    <StyledImage
      src="/images/profile/dmf-4.jpg"
      alt="Background Image"
      className="img1"
      sources={[
        {
          srcset: [
            "/images/profile/dmf-4.jpg 1x",
            "/images/profile/dmf-4.jpg 2x",
          ],
        },
      ]}
    />
    <StyledImage
      src="/images/profile/dmf-93.jpg"
      alt="Background Image"
      className="img3"
      sources={[
        {
          srcset: [
            "/images/profile/dmf-93.jpg 1x",
            "/images/profile/dmf-93.jpg 2x",
          ],
        },
      ]}
    />
  </Wrapper>
);

export default ImageSection;



// WEBPACK FOOTER //
// ./src/components/ImageSection/index.js